<template>
  <div class="modal fade" tabindex="-1" role="dialog">
    <!-- modal-add-update-credit-card -->
    <modal-add-credit-card
      v-if="requestedModal === 'addCreditCard'"
      ref="activeModalRef"
      :lang="lang"
      :modal-data="modalData"
    ></modal-add-credit-card>

    <!-- modal-add-update-direct-debit-account -->
    <modal-add-update-direct-debit-account
      v-if="requestedModal === 'addUpdateDirectDebitAccount'"
      ref="activeModalRef"
      :lang="lang"
      :modal-data="modalData"
    ></modal-add-update-direct-debit-account>

    <!-- modal-add-update-direct-debit-account -->
    <modal-conversation-thread-msg-original
      v-if="requestedModal === 'conversationThreadMsgOriginal'"
      ref="activeModalRef"
      :lang="lang"
      :modal-data="modalData"
    ></modal-conversation-thread-msg-original>

    <!-- modal-delete-offer -->
    <modal-delete-offer
      v-if="requestedModal === 'deleteOffer'"
      ref="activeModalRef"
      :lang="lang"
      :modal-data="modalData"
      @delete-offer="emit('delete-offer')"
      @hide-modal="hideModal"
    ></modal-delete-offer>

    <!-- modal-delete-offer -->
    <modal-offer-stats
      v-if="requestedModal === 'offerStats'"
      ref="activeModalRef"
      :lang="lang"
      :modal-data="modalData"
    ></modal-offer-stats>

    <!-- modal-delete-offer -->
    <modal-save-search
      v-if="requestedModal === 'saveSearch'"
      ref="activeModalRef"
      :lang="lang"
      :modal-data="modalData"
      @hide-modal="hideModal"
    ></modal-save-search>

    <!-- modal-delete-offer -->
    <modal-offer-request-msg
      v-if="requestedModal === 'offerRequestMsg'"
      ref="activeModalRef"
      :lang="lang"
      :modal-data="modalData"
      @msg-sent="emit('msg-sent')"
      @hide-modal="hideModal"
    ></modal-offer-request-msg>
  </div>
</template>

<script setup>
import { ref } from "vue";
import axios from "axios";
import _ from "lodash";

import ModalAddCreditCard from "./ModalAddCreditCard.vue";
import ModalAddUpdateDirectDebitAccount from "./ModalAddUpdateDirectDebitAccount.vue";
import ModalConversationThreadMsgOriginal from "./ModalConversationThreadMsgOriginal.vue";
import ModalDeleteOffer from "./ModalDeleteOffer.vue";
import ModalOfferStats from "./ModalOfferStats.vue";
import ModalOfferRequestMsg from "./ModalOfferRequestMsg.vue";
import ModalSaveSearch from "./ModalSaveSearch.vue";

const emit = defineEmits(["delete-offer", "msg-sent"]);

const requestedModal = ref("");
const lang = ref([]);
const modalData = ref({});
const activeModalRef = ref(null);

/**
 * load a modal
 */
const loadModal = (newRequestedModal, modalDataValue) => {
  if (newRequestedModal === "") {
    return;
  }

  modalData.value = modalDataValue !== undefined ? modalDataValue : {};

  if (_.isEmpty(lang.value)) {
    // load language data
    axios
      .get(`/web-api/language`, {
        params: {
          section: "modal",
        },
      })
      .then((response) => {
        lang.value = response.data.lang;
        requestedModal.value = newRequestedModal;
        renderModal();
      })
      .catch();
  } else {
    requestedModal.value = newRequestedModal;
    renderModal();
  }
};

/**
 * render modal
 */
const renderModal = () => {
  setTimeout(() => {
    if (activeModalRef.value) {
      activeModalRef.value.showModal();
    }
  }, 300);
};

/**
 * hide Modal
 */
const hideModal = () => {
  if (activeModalRef.value) {
    activeModalRef.value.hideModal();
  }
};

defineExpose({
  loadModal,
  hideModal,
});
</script>
